import { createContext } from "react";

const IntegrationsContext = createContext();

export default IntegrationsContext;